import { DateFactory } from 'rhg-vue-common'
import { language } from '@/infrastructure/Configuration'

export default class Group {
  static fromJSON(json) {
    return new Group({
      title: json.title,
      staysPublic: json.staysPublic,
      staysMember: json.staysMember,
      orderBy: json.orderBy,
      conditions: json.conditions,
      singleStayType: json.singleStayType,
      dealOfTheDay: json.dealOfTheDay,
      redeemable: json.redeemable
    })
  }

  constructor({
    title,
    orderBy,
    staysMember,
    staysPublic,
    selectedStay,
    conditions,
    singleStayType,
    dealOfTheDay,
    redeemable
  }) {
    this.title = title
    this.orderBy = orderBy
    this.staysMember = staysMember
    this.staysPublic = staysPublic
    this.selectedStay = selectedStay || this.getCheapestStay(this.getAllStays())
    this.conditions = conditions || {}
    this.singleStayType = singleStayType
    this.dealOfTheDay = dealOfTheDay
    this.redeemable = redeemable
    this.selectedPublicStay = this.getCheapestStay(staysPublic)
    this.selectedMemberStay = this.getCheapestStay(staysMember)
  }

  isDealOfTheDay = () => !!this.dealOfTheDay
  dealExpiryDate = () => this.dealOfTheDay?.endDate

  getCheapestStay(stays) {
    return stays.sort((a, b) => a.weight() - b.weight())[0]
  }

  getAllStays = () => {
    return [...this.staysMember, ...this.staysPublic]
  }

  getAllStaysLength = () => {
    return this.getAllStays().length
  }

  setSelectedStay = stay => {
    return new Group({ ...this, selectedStay: stay })
  }

  changeCurrency(currency) {
    return new Group({
      ...this,
      staysMember: this.staysMember.map(stay => stay.changeCurrency(currency)),
      staysPublic: this.staysPublic.map(stay => stay.changeCurrency(currency)),
      selectedStay: this.selectedStay.changeCurrency(currency),
      selectedPublicStay: this.selectedPublicStay?.changeCurrency(currency),
      selectedMemberStay: this.selectedMemberStay?.changeCurrency(currency)
    })
  }

  getFreeCancellationUpTo() {
    const pattern =
      language !== 'tr'
        ? DateFactory.DatePatterns.FULL_DATE_SHORT_TIME
        : DateFactory.DatePatterns.FULL_DATE_FULL_TIME
    return DateFactory.objectFromPattern(this.conditions.freeCancellationBefore, false).format(
      pattern
    )
  }

  findStayById(stayId) {
    return [...this.staysMember, ...this.staysPublic].find(stay => stay.id === stayId)
  }

  payAtProperty() {
    return this.conditions.payAtProperty
  }

  hasPublicRate() {
    return this.staysPublic.length > 0
  }

  hasMemberRates() {
    return this.staysMember.length > 0
  }

  creditCardNotNeeded() {
    return this.conditions.creditCardNotNeeded
  }

  freeCancellation() {
    return this.conditions.freeCancellation
  }

  applyFilter(filter) {
    const filterAndSort = stays =>
      stays
        .map(stay => stay.applyFilter(filter))
        .filter(result => result.fullMatch)
        .map(result => result.stay)
        .sort((a, b) => a.mealPlanDto.index - b.mealPlanDto.index)

    const sortedStaysMember = filterAndSort(this.staysMember)
    const sortedStaysPublic = filterAndSort(this.staysPublic)

    return new Group({
      ...this,
      staysMember: sortedStaysMember,
      staysPublic: sortedStaysPublic,
      singleStayType: !(!!sortedStaysMember.length && !!sortedStaysPublic.length)
    })
  }
}
